// extracted by mini-css-extract-plugin
export default {"Container":"InputGroup_Container__MxyEL"};